// extracted by mini-css-extract-plugin
export var container = "_al-0";